import React from 'react';
import { styles } from './MenuButton.css';
import { ArrowRight } from '@jbhi-fi/lanyard-ui/components/Icons';

export type MenuButtonProps = {
  label: string;
  isOpen: boolean;
  onClick: () => void;
  href?: string;
};

const Component = ({
  href,
  children,
  data_t,
  ...rest
}: React.PropsWithChildren<{
  href?: string;
  className?: string;
  onClick: () => void;
  data_t?: string;
}>): React.ReactElement => {
  if (href)
    return (
      <a href={href} data-t={data_t} {...rest}>
        {children}
      </a>
    );

  return (
    <button type="button" aria-haspopup="menu" data-t={data_t} {...rest} data-testid="navigation-menu-button">
      {children}
      <span className={styles.arrow}>
        <ArrowRight height="8px" width="8px" />
      </span>
    </button>
  );
};

export const MenuButton = ({ label, onClick, isOpen = false, href }: MenuButtonProps) => {
  return (
    <Component
      aria-expanded={isOpen ? 'true' : 'false'}
      className={styles.button({ active: isOpen })}
      onClick={onClick}
      href={href}
      data_t={label.replace(/\s/g, '')}
    >
      {label}
    </Component>
  );
};
